import { ANNOTATION_ICON, cn } from "src/helpers";
import { fetchProjectsSummaryApiRequest } from "src/services/requests/CommercialAndIndustrial";
import CounterAnimation from "src/shadcn/components/custom/Animations/CounterAnimation";
import { REFERENCES_ANALYSIS } from "../../Services/Component/modules";
import useFetchData from "../../Services/useHandleGetTop5Products";
import { useNavigate } from "react-router-dom";
import { MAIN_ROUTES_CONST } from "src/navigations/modules";

const SuccessStory = () => {
  const navigate = useNavigate();
  const { data: projectSummary } = useFetchData(fetchProjectsSummaryApiRequest);
  return (
    <div className="space-y-8 pt-8 pb-8">
      <div className="px-16">
        <div className="flex items-center space-x-2">
          {" "}
          <img src={ANNOTATION_ICON} style={{ width: "20px", height: "20px" }} alt="ANNOTATION_ICON" />{" "}
          <span className=" font-bold text-3xl">Success Story</span>
        </div>
        <div className="px-[30px]">A showcase of successful transactions.</div>
      </div>
      <div className="px-8 md:px-16   space-y-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 lg:max-w-[50vw] gap-4 mx-auto">
          {REFERENCES_ANALYSIS.map(({ count, dataKey, name, annotation }: any) => {
            if (projectSummary[dataKey]) {
              count = projectSummary[dataKey];
            }
            return (
             <div
                className={cn("flex flex-col items-center space-y-1 p-4 ", {
                  "cursor-pointer": name === "Successful Transaction",
                })}
                key={name}
                onClick={() => {
                  if (name === "Successful Transaction") {
                    navigate("/"+MAIN_ROUTES_CONST.marketplace + "?projectStatus=CLOSED");
                  }
                }}
              >
                <div className="font-bold text-3xl text-primary">
                  <CounterAnimation from={0} to={count} />
                  {annotation}
                </div>
                <div className="text-center">{name}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SuccessStory;
